import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from "@angular/forms";

export function passwordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value ?? "";
        const errors: ValidationErrors = {};

        if (value.length < 16) errors["minLength"] = true;
        if (!/[A-Z]/.test(value)) errors["missingUppercase"] = true;
        if (!/[a-z]/.test(value)) errors["missingLowercase"] = true;
        if (!/\d/.test(value)) errors["missingNumber"] = true;
        if (!/[^A-Za-z0-9]/.test(value)) errors["missingSymbol"] = true;

        return Object.keys(errors).length ? errors : null;
    };
}

export function passwordsMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const form = group as FormGroup;
        const newPassword = form.get("newPassword")?.value ?? "";
        const confirmPassword = form.get("confirmPassword")?.value ?? "";
        const confirmControl = form.get("confirmPassword");

        if (newPassword === confirmPassword) {
            if (confirmControl?.errors) {
                // Remove only the mismatch error, preserving any other errors on the control
                const { _passwordsMismatch, ...remainingErrors } = confirmControl.errors;
                confirmControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
            }
            return null;
        } else {
            // Set the error on the control directly so it's accessible via confirmPassword.errors
            confirmControl?.setErrors({ ...confirmControl.errors, passwordsMismatch: true });
            return { passwordsMismatch: true };
        }
    };
}

export const passwordRequirementsList: { label: string; check: (v: string) => boolean }[] = [
    { label: "At least 16 characters", check: (v: string) => v.length >= 16 },
    { label: "One uppercase letter", check: (v: string) => /[A-Z]/.test(v) },
    { label: "One lowercase letter", check: (v: string) => /[a-z]/.test(v) },
    { label: "One number", check: (v: string) => /\d/.test(v) },
    { label: "One symbol", check: (v: string) => /[^A-Za-z0-9]/.test(v) }
];
